
const digest = '73d7cd28efda670ec31c4b3fbf561c5fd56bce28b94df6ab0c079cfeb412f759';
const classes = {"wrapper":"_wrapper_1ygav_1","material":"_material_1ygav_7"};
const css = `._wrapper_1ygav_1 {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: stretch;
}
._wrapper_1ygav_1 ._material_1ygav_7 {
  width: 12px;
  height: 100%;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  